// extracted by mini-css-extract-plugin
export default {"radio_box":"Radio_radio_box__gUS9-","official_st":"Radio_official_st__fmZF-"};